import { render } from "./card_product.vue?vue&type=template&id=0ab363cc&scoped=true"
import script from "./card_product.vue?vue&type=script&lang=js"
export * from "./card_product.vue?vue&type=script&lang=js"

import "./card_product.vue?vue&type=style&index=0&id=0ab363cc&lang=css&scoped=true"

import exportComponent from "/Users/jean-yvesfournet/Documents/projects/javascript/vue/shop-flash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab363cc"]])

export default __exports__